import React from 'react';
import { Step } from 'components/SteppedModal';
import useSocialShareModalFooter from 'containers/SocialShareModal/SocialShareModalFooter';
import { TikTokSocialShareStep } from '../../types';
import TikTokPostComposerStep, {
  TikTokPostComposerStepProps,
} from './TikTokPostComposerStep';

export type UseTikTokPostComposerStepConfig = TikTokPostComposerStepProps & {
  onShare: () => void;
};

export default function useTikTokPostComposerStep({
  brandedContentSelected,
  privacyLevel,
  userAllowance,
  onPrivacyLevelChange,
  onUserAllowanceChange,
  onShare,
}: UseTikTokPostComposerStepConfig): Step<TikTokSocialShareStep> {
  const footerConfig = useSocialShareModalFooter({
    disableFooterButtons: !privacyLevel,
    onShare,
  });

  return {
    ...footerConfig,
    id: 'composer',
    component: (
      <TikTokPostComposerStep
        {...{
          brandedContentSelected,
          privacyLevel,
          userAllowance,
          onPrivacyLevelChange,
          onUserAllowanceChange,
        }}
      />
    ),
  };
}
